/*# sourceMappingURL=vital-signs.component-MRW76WGM.css.map */
